import React from "react";
import DocumentDetail from "../common/DocumentDetail";
import { BLANK_PLACEHOLDER } from "config/constant";
import { REPORT_FIELD as FIELD } from "config/documentConstant";
import { DocumentDtoWithAny } from "models/document/DocumentDtoWithAny";
import { Font, Text, View } from "@react-pdf/renderer";
import Html from "react-pdf-html";
import { styles } from "pages/document/work/detail/style";
import { sanitizeContent } from "utils/htmlTranslate";

Font.registerEmojiSource({
  format: "png",
  url: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@15.0.1/img/apple/64/",
  withVariationSelectors: true,
});

interface ReportDetailProps {
  documentData: DocumentDtoWithAny["documentData"];
}

const ReportDetail = ({ documentData }: ReportDetailProps) => {
  return (
    <>
      <DocumentDetail.Section>
        <DocumentDetail.Field label={FIELD.TITLE.label}>
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.TITLE.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <View
          style={{ display: "flex", flexDirection: "row", marginVertical: 10 }}
        >
          <Text
            style={{
              width: "30mm",
              fontFamily: "Pretendard",
              fontSize: "10pt",
              fontWeight: 700,
              marginTop: 4,
            }}
          >
            내용
          </Text>
          <View
            style={{
              display: "flex",
              flex: 1,
              marginTop: 4,
              marginLeft: 11,
            }}
          >
            <Html stylesheet={styles}>
              {sanitizeContent(documentData.content) || BLANK_PLACEHOLDER}
            </Html>
          </View>
        </View>
      </DocumentDetail.Section>
    </>
  );
};

export default ReportDetail;
